import create from 'zustand'

export const useHeaderNav = create(set => ({
  menuVisible: false,
  setMenuVisible: data => set(state => ({ menuVisible: data })),
}))
